import { PartnersRegistrationState } from '@store/partners-registration/PartnersRegistrationState';
import { PartnerRequestDef } from '@api/types/PartnerRequestDef';



export const convertToPartnerRequestDef = (state: PartnersRegistrationState): PartnerRequestDef | null => {
	if (!state.contactPerson) return null;
	if (!state.clientName) return null;
	if (!state.email) return null;
	if (!state.phoneNumber) return null;
	if (!state.invoiceStreet) return null;
	if (!state.invoiceCity) return null;
	if (!state.invoicePostalCode) return null;
	if (process.env.SHOW_COMPANY_REGISTRATION_ID === 'TRUE' && !state.registrationNumber) return null;
	if (!state.vatnumber) return null;

	return {
		contactPerson: state.contactPerson,
		clientName: state.clientName,
		email: state.email,
		phoneNumber: state.phoneNumber,
		
		street: state.street,
		city: state.city,
		postalCode: state.postalCode,
		invoiceStreet: state.invoiceStreet,
		invoiceCity: state.invoiceCity,
		invoicePostalCode: state.invoicePostalCode,
		
		registrationNumber: state.registrationNumber,
		vatnumber: state.vatnumber,
		salesMan: state.salesMan,
		message: state.message,
	}
}